import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

export const SidebarList = styled.ul`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(12.0)};
  width: 100%;
  list-style: none;
`;

export const SidebarListItem = styled.li`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

interface ISidebarItemProps {
  color?: 'default' | 'bluegray' | 'red' | 'white';
  size?: 'small' | 'large';
}

export const SidebarListItemLabel = styled.label<ISidebarItemProps>`
  position: relative;
  display: flex;
  flex-grow: 0;
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.regular};
  font-size: ${toRem(14)};
  line-height: 125%;
  white-space: nowrap;
  color: ${theme.color.neutral[800]};

  ${({ size }) =>
    size === 'large' &&
    css`
      font-size: ${toRem(16.5)};
      font-weight: ${theme.font.weight.semiBold};
      color: ${theme.color.neutral[900]};
    `}

  ${({ color }) =>
    color === 'bluegray' &&
    css`
      color: ${theme.color.neutral[500]};
    `}

  ${({ color }) =>
    color === 'red' &&
    css`
      color: ${theme.color.danger.medium};
    `}

    ${({ color }) =>
    color === 'white' &&
    css`
      color: ${theme.color.white};
    `}
`;

export const SidebarListItemValue = styled.span<ISidebarItemProps>`
  position: relative;
  display: flex;
  flex-grow: 0;
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.regular};
  font-size: ${toRem(14)};
  line-height: 100%;
  color: ${theme.color.neutral[900]};

  ${({ size }) =>
    size === 'large' &&
    css`
      font-size: ${toRem(22)};
    `}

  ${({ color }) =>
    color === 'bluegray' &&
    css`
      color: ${theme.color.neutral[500]};
    `}

  ${({ color }) =>
    color === 'red' &&
    css`
      color: ${theme.color.danger.medium};
    `}

    ${({ color }) =>
    color === 'white' &&
    css`
      color: ${theme.color.white};
    `}
`;
